import { emit, mech, nextId } from './tick.js';
/** Long enough to outlast any round (toggle stances end explicitly). */
export const TOGGLE_TICKS = 1_000_000;
export function addEffect(t, slot, kind, source, ticks, params) {
    const effect = {
        id: nextId(t),
        kind,
        source,
        ticksLeft: Math.max(1, ticks),
        params,
    };
    mech(t, slot).effects.push(effect);
    emit(t, { t: 'effectStart', slot, kind, id: effect.id, ticks: effect.ticksLeft });
    return effect;
}
/** Re-applies a non-stacking effect: the existing one of the same kind and source is extended. */
export function refreshEffect(t, slot, kind, source, ticks, params) {
    const c = mech(t, slot);
    const existing = c.effects.find((e) => e.kind === kind && e.source === source);
    if (existing) {
        existing.ticksLeft = Math.max(existing.ticksLeft, ticks);
        existing.params = params;
        return existing;
    }
    return addEffect(t, slot, kind, source, ticks, params);
}
export function removeEffect(t, slot, id) {
    const c = mech(t, slot);
    const e = c.effects.find((x) => x.id === id);
    if (!e)
        return;
    c.effects = c.effects.filter((x) => x.id !== id);
    emit(t, { t: 'effectEnd', slot, kind: e.kind, id: e.id });
}
export function removeEffectsOfKind(t, slot, kind) {
    const c = mech(t, slot);
    for (const e of c.effects) {
        if (e.kind === kind)
            emit(t, { t: 'effectEnd', slot, kind: e.kind, id: e.id });
    }
    c.effects = c.effects.filter((e) => e.kind !== kind);
}
/** Crowd control respects immunity; the impulse applies in the next movement step. */
export function applyImpulse(t, slot, source, impulse) {
    if (t.mods[slot].ccImmune || !mech(t, slot).alive)
        return false;
    addEffect(t, slot, 'knockback', source, 1, { impulse: { ...impulse } });
    return true;
}
/** Horizontal push away from a point (plus a small lift so it reads as a shove). */
export function knockbackFrom(t, slot, source, from, speed, lift = 0) {
    if (speed <= 0 && lift <= 0)
        return false;
    const c = mech(t, slot);
    let dx = c.body.position.x - from.x;
    let dz = c.body.position.z - from.z;
    const len = Math.hypot(dx, dz);
    if (len < 1e-6) {
        dx = 1;
        dz = 0;
    }
    else {
        dx /= len;
        dz /= len;
    }
    return applyImpulse(t, slot, source, { x: dx * speed, y: lift, z: dz * speed });
}
//# sourceMappingURL=effects.js.map